import { useContext } from 'react';

import { GaugeChartColorContext } from '../contexts/GaugeChartColorContext.js';

export const useGaugeChartColorContext = () =>
  useContext(GaugeChartColorContext);
